import * as fabric from 'office-ui-fabric-react';
import { FC } from 'react';
import PageHeader from '../../../../components/layout/PageHeader';
import DeviceDoorScreens from './doorScreens/DeviceDoorScreens';
import DeviceInfoScreens from './infoScreens/DeviceInfoScreens';
import DeviceTerminals from './terminals/DeviceTerminals';

const DevicesPage: FC = () => {
    return (
        <div className="ms-Grid" dir="ltr">
            <PageHeader text="Įrenginiai" />
            <div className="ms-Grid-row" style={{ paddingTop: '10px' }}>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <fabric.Pivot style={{ textAlign: 'center' }}>
                        <fabric.PivotItem headerText="Info ekranai">
                            <DeviceInfoScreens />
                        </fabric.PivotItem>
                        <fabric.PivotItem headerText="Durų ekranai">
                            <DeviceDoorScreens />
                        </fabric.PivotItem>
                        <fabric.PivotItem headerText="Terminalai">
                            <DeviceTerminals />
                        </fabric.PivotItem>
                    </fabric.Pivot>
                </div>
            </div>
        </div>
    );
};

export default DevicesPage;
